import { contextPromise } from '@web-platform/shared-banana-utils-frontend/src/helpers/contextPromise';
import { isAcornRequest } from '@web-platform/shared-universal-utils-frontend/src/helpers/isAcornRequest';

if (!isAcornRequest()) {
  contextPromise();
}

import(
  /* webpackChunkName: "Bootstrap" */
  './bootstrap'
)
  .then((bootstrap) => bootstrap.run())
  .catch((error) => {
    throw error;
  });

export {};
